import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { loginUrlForCurrentLocation } from "../../utils/returnUrl";
import { LoadingScreen } from "../common/LoadingScreen";

interface AffiliateProtectedRouteProps {
  children: React.ReactNode;
}

export function AffiliateProtectedRoute({
  children,
}: AffiliateProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user || user.role !== "AFFILIATE") {
    // Carry where they were headed, so signing in lands them there instead of
    // on the dashboard. Matters most for shared join links, where the `?p=`
    // token in the URL is the entire reason for the visit.
    return <Navigate to={loginUrlForCurrentLocation(location)} replace />;
  }

  return <>{children}</>;
}
